import { ANALYTICS_V3_PATH } from 'views/main/routes/routes';
import { NoiseReductionByServiceReductionType } from '../api/types';
import {
  DateRange,
  IncidentAnalyticsFilterForm,
  OnCallUsersAnalyticsFilterForm,
} from '../hooks/types';
import { IncidentsIcon } from 'icons';

import moment from 'moment';
import { Box } from '@chakra-ui/react';
import { OnCallUserIcon } from '../icons/on-call-user';
import BillingService from 'core/services/service.billing';

export const options = [
  {
    label: 'Incident Analytics',
    tabName: 'Incident Analytics',
    value: `${ANALYTICS_V3_PATH}/incident-analytics`,
    isBeta: false,
    icon: (
      <Box
        width="16px"
        height="16px"
        sx={{ '& svg path': { stroke: '#09305A' } }}
        justifyContent="center"
        alignItems="center"
        display="flex"
      >
        <IncidentsIcon stroke="#09305A" />
      </Box>
    ),
  },
  {
    label: 'On Call Hours Per User',
    tabName: 'On Call Analytics',
    value: `${ANALYTICS_V3_PATH}/on-call-analytics`,
    isBeta: true,
    icon: <OnCallUserIcon />,
  },
];

export const RESPONSE_METRICS_OPTIONS = ['mean', 'median', 'p75', 'p90', 'p99'] as const;

export const RESPONSE_METRICS_OPTIONS_MAP = {
  mean: 'Mean',
  median: 'Median',
  p75: '75th Percentile',
  p90: '90th Percentile',
  p99: '99th Percentile',
};

export const INCIDENT_STATUS_COLORS = {
  triggered: '#A951ED',
  acknowledged: '#FDCF2D',
  resolved: '#209628',
};

export const INCIDENT_STATUS_LABELS = {
  triggered: 'Triggered',
  acknowledged: 'Acknowledged',
  resolved: 'Resolved',
};

export const INCIDENT_PRIORITY_COLORS = {
  P1: '#FC164E',
  P2: '#EF5D1E',
  P3: '#E0A426',
  P4: '#5484CC',
  P5: '#7E7E7E',
  unset: '#E1E6EB',
};

export const INCIDENT_PRIORITY_LABELS = {
  P1: 'Priority 1',
  P2: 'Priority 2',
  P3: 'Priority 3',
  P4: 'Priority 4',
  P5: 'Priority 5',
  unset: 'Unset Priority',
};

export const INCIDENT_STATUS_DATA = [
  { name: 'Triggered', value: 33500, color: '#A951ED' },
  { name: 'Acknowledged', value: 3100, color: '#FDCF2D' },
  { name: 'Resolved', value: 23400, color: '#209628' },
];

export const INCIDENT_PRIORITY_DATA = [
  { name: INCIDENT_PRIORITY_LABELS.P1, value: 33500, color: INCIDENT_PRIORITY_COLORS.P1 },
  { name: INCIDENT_PRIORITY_LABELS.P2, value: 31000, color: INCIDENT_PRIORITY_COLORS.P2 },
  { name: INCIDENT_PRIORITY_LABELS.P3, value: 23400, color: INCIDENT_PRIORITY_COLORS.P3 },
  { name: INCIDENT_PRIORITY_LABELS.P4, value: 23400, color: INCIDENT_PRIORITY_COLORS.P4 },
  { name: INCIDENT_PRIORITY_LABELS.P5, value: 23400, color: INCIDENT_PRIORITY_COLORS.P5 },
  { name: INCIDENT_PRIORITY_LABELS.unset, value: 23400, color: INCIDENT_PRIORITY_COLORS.unset },
];

export const INCIDENT_COUNT_OVER_TIME_DATA = [
  { name: 'Mon', value: 120 },
  { name: 'Tue', value: 200 },
  { name: 'Wed', value: 150 },
  { name: 'Thu', value: 80 },
  { name: 'Fri', value: 70 },
  { name: 'Sat', value: 110 },
  { name: 'Sun', value: 130 },
];

export const NOISE_REDUCTION_LABELS = {
  [NoiseReductionByServiceReductionType.Apta]: 'Transient',
  [NoiseReductionByServiceReductionType.Dedup]: 'Deduped',
  [NoiseReductionByServiceReductionType.Iag]: 'Intelligently Grouped',
  [NoiseReductionByServiceReductionType.Suppressed]: 'Suppressed',
  Triggered: 'Triggered',
};

export const NOISE_REDUCTION_COLORS = {
  [NoiseReductionByServiceReductionType.Apta]: '#18A86D',
  [NoiseReductionByServiceReductionType.Dedup]: '#706EC4',
  [NoiseReductionByServiceReductionType.Iag]: '#E05677',
  [NoiseReductionByServiceReductionType.Suppressed]: '#7E7E7E',
  Triggered: '#5484CC',
};

export const initialFilters: IncidentAnalyticsFilterForm = {
  tagKey: null,
  tagValue: [],
  priority: [],
  assignee: {
    users: [],
    squads: [],
    myUsers: [],
    mySquads: [],
    meAndMySquads: false,
  },
  serviceOwner: {
    users: [],
    squads: [],
    myUsers: [],
    mySquads: [],
    meAndMySquads: false,
  },
  service: [],
};

export const onCallUserPerHourinitialFilters: OnCallUsersAnalyticsFilterForm = {
  schedule: [],
  scheduleOwner: {
    users: [],
    squads: [],
    myUsers: [],
    mySquads: [],
    meAndMySquads: false,
  },
  searchTerm: '',
};

export const defaultDateRange: DateRange = {
  startDate: moment().subtract(7, 'days').startOf('day').toDate(),
  endDate: moment().endOf('day').toDate(),
  timeZone: '',
};

export const ANALYTIC_V3_EVENTS = {
  INCIDENT_ANALYTICS_PAGE_VIEWED: 'Analytics V3 Page Viewed',
  INCIDENT_ANALYTICS_FILTER_APPLIED: 'Analytics V3 Filter Applied',
  INCIDENT_ANALYTICS_DATE_FILTER_APPLIED: 'Analytics V3 Date Filter Applied',
  INCIDENT_ANALYTICS_CHART_EXPORT_CLICKED: 'Analytics V3 Chart Exported',
  INCIDENT_ANALYTICS_CHART_GROUP_BY_APPLIED: 'Analytics V3 Chart Group By Applied',
  INCIDENT_ANALYTICS_CHART_LEVEL_FILTER_APPLIED: 'Ananytics V3 Chart Level Filter Applied',
  INCIDENT_ANALYTICS_AGGREGATE_MODIFIED: 'Analytics V3 Aggregate By Modified',
  INCIDENT_ANALYTICS_CHART_SORTED: 'Analytics V3 Chart Sorted',
};
